import { Route, Routes } from "react-router";
import Home from "./pages/Home";
import PreviewPage from "./pages/PreviewPage";
import SamplePage from "./pages/SamplePage";
import TermsPage from "./pages/TermsPage";
import PriceAdminPage from "./pages/PriceAdminPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/preview/:id" element={<PreviewPage />} />
      <Route path="/sample" element={<SamplePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/admin/prices" element={<PriceAdminPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
